import { useRecoilState, useRecoilValue } from 'recoil';

import {useFetchWrapper} from '_helpers';
import {studentsAtom, currentClassAtom, alertBachAtom} from '_state';

export{ useStudentInfoAction };

function useStudentInfoAction (param) {
    const fetchWrapper = useFetchWrapper();
    const [, setStudents] = useRecoilState(studentsAtom);
    const currentClass = useRecoilValue(currentClassAtom);
    const [alert, setAlert] = useRecoilState(alertBachAtom);

    async function getStudentList(Class){
        console.log("get student list called from studentInfo-action");
        const response = await fetchWrapper.get(`/api/classes/${Class.class_id}/members/infors`, null, null);
        if (response == null) {
            console.log("No response.");
            return null;
        }
        const rawjson = await response.json();
        console.log(rawjson);
        setStudentData(rawjson);
        return rawjson;
    }

    function setStudentData (rawjson) {
        let data = rawjson.message
        console.log("Students info : ", data);
        setStudents(data);
        // console.log(students);
    }

    async function deleteStudent(Id){
        console.log('from delete Student ',Id);
        var urlencoded = new URLSearchParams();
        urlencoded.append("members", `["${Id}"]`); 
        const response = await fetchWrapper.delete(`/api/classes/${currentClass.class_id}/members/delete`, "application/x-www-form-urlencoded", urlencoded);
        if (response == null) {
            console.log("No response.");
            setAlert({message: "Lỗi", description: "Không thể xóa thành viên !"});
            return null;
        }
        response.json().then(rawjson => { 
            console.log(rawjson);
            if (rawjson.status == "Success") {
                getStudentList(currentClass);
                setAlert({message: "Thành công", description: "Xóa thành viên thành công !"});
            }
            return rawjson;
          }); 
    }

    async function updateStudent(studentId, fields) {
        const body = new URLSearchParams();
        Object.keys(fields || {}).forEach(key => {
            if (fields[key] !== undefined) body.append(key, fields[key]);
        });
        const res = await fetchWrapper.put(
            `/api/manager/students/${studentId}`,
            'application/x-www-form-urlencoded',
            body
        );
        return res.json();
    }

    async function AddStudent(studentIds) {
        studentIds = studentIds.replace(/\s+/g, '');
        var idArr = studentIds.split(',');
        var converted = idArr.map(id => `"${id}"`).join(',');
        var urlencoded = new URLSearchParams();
        urlencoded.append("members", `[${converted}]`);
        const response = await fetchWrapper.post(`/api/classes/${currentClass.class_id}/members/add`, "application/x-www-form-urlencoded", urlencoded);
        if (response == null) {
            console.log("No response.");
            setAlert({message: "Lỗi", description: "Không thể thêm thành viên !"});
            return null;
        }
        response.json().then(rawjson => { 
            if (rawjson.status == "Success") {
                getStudentList(currentClass);
                var description;
                var message = 'Thành công';
                description = `Thêm các thành viên :${rawjson.message.registered} thành công ! Không thể các thành viên :${rawjson.message.failed}`
                if (rawjson.message.registered.length === 0) {
                    description = `Không thể thêm thành viên` ;
                    message = "Thất bại";
                }
                if (rawjson.message.failed.length === 0){
                    description = `Thêm thành viên thành công !`;
                    } 
                setAlert({message: message, description: description});
            }
            return rawjson;
          }); 
    }

    async function refresh() {
        if (currentClass) {
            await getStudentList(currentClass);
        }
    }

    return {
        getStudentList : getStudentList,
        deleteStudent : deleteStudent,
        AddStudent : AddStudent,
        updateStudent,
        refresh,
    }
}
